import React, { useEffect, useId, useState } from 'react'
import classes from './Dashboard.module.css'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import BtnWrapper from '../../UI/BtnWrapper';
import SecBTN from '../../UI/SecBTN';
import OverallAnalytics from '../../Components/OverallAnalytics/OverallAnalytics';
import CustomModal from '../../UI/Modals/Modals';
import { Col, Row } from 'react-bootstrap';
import Select from '../../UI/Select/Select';
import DatePick from '../../Components/DatePicker/DatePicker';
import StudentwiseAnalytics from '../../Components/StudentwiseAnalytics/StudentwiseAnalytics';
import userService from '../../app/services/user.service';

const Dashboard = props => {
    const btnType = ["My Performance","Student performance"]
    const [activeTab, setActiveTab]= useState(btnType[0])
    const btnType1 = ["Over-all Analytics", "Student-wise Analytics"];
    const [isPending, setISPending] = useState(btnType1[0]);
    const [filterPopup,setFilterPopup] = useState(false);
    const id = useId()
    useEffect(() => {
      userService.getTestData()
      .then(res =>{
        console.log(res)
      })
      .catch(error => console.log(error))
    },[])
  return (
    <>
      <CustomModal
        show={filterPopup}
        size="lg"
        onHide={() => setFilterPopup(false)}
      >
        <h5 className="mb-4">Choose The Filters</h5>
        <Row className="mb-4">
          <Col lg={6} md={12} sm={12} className="mb-2">
            <label htmlFor={id + "session"}>Session :</label>
            <Select id={id + "session"}>
              <option value="" selected disabled>
                Select Session
              </option>
              <option value="1">1</option>
              <option value="2">2</option>
            </Select>
          </Col>
          <Col lg={6} md={12} sm={12} className="mb-2">
            <label htmlFor={id + "Class"}>Class :</label>
            <Select id={id + "Class"}>
              <option value="" selected disabled>
                Select Class
              </option>
              <option value="1">1</option>
              <option value="2">2</option>
            </Select>
          </Col>
          <Col lg={6} md={12} sm={12} className="mb-2">
            <label htmlFor={id + "Stream"}>Stream :</label>
            <Select id={id + "Stream"}>
              <option value="" selected disabled>
                Select Stream
              </option>
              <option value="1">1</option>
              <option value="2">2</option>
            </Select>
          </Col>
          <Col lg={6} md={12} sm={12} className="mb-2">
            <label htmlFor={id + "Batch"}>Batch :</label>
            <Select id={id + "Batch"}>
              <option value="" selected disabled>
                Select Batch
              </option>
              <option value="1">1</option>
              <option value="2">2</option>
            </Select>
          </Col>
          <Col lg={6} md={12} sm={12} className="mb-2">
            <label htmlFor={id + "TestName"}>Test Name :</label>
            <Select id={id + "TestName"}>
              <option value="" selected disabled>
                Select Test Name
              </option>
              <option value="1">1</option>
              <option value="2">2</option>
            </Select>
          </Col>
          <Col lg={6} md={12} sm={12} className="mb-2">
            <label htmlFor={id + "TestDate"}>Test Date :</label>
            <DatePick
              required={true}
              placeholder="Select Test Date"
              // selected={reqData.to_be_held_on}
            />
          </Col>
        </Row>
        <div className="text-center">
          <SecBTN className="sec-btn1" onClick={() => setFilterPopup(false)}>
            Save Filters
          </SecBTN>
        </div>
      </CustomModal>
      <div className="section">
        <h4 className="">Dashboard</h4>
        <Breadcrumb>
          <Breadcrumb.Item active>Create Paper</Breadcrumb.Item>
          <Breadcrumb.Item active>{activeTab}</Breadcrumb.Item>
          {activeTab == btnType[1] && (
            <Breadcrumb.Item active>{isPending}</Breadcrumb.Item>
          )}
        </Breadcrumb>
        <div>
          {/*  */}
          {btnType.map((type) => {
            return (
              <button
                key={type}
                className={`${classes.tab} ${
                  activeTab === type ? classes.tabActive : ""
                }`}
                onClick={() => setActiveTab(type)}
              >
                {type}
              </button>
            );
          })}
          {activeTab === btnType[0] && <div>{activeTab}</div>}
          {activeTab === btnType[1] && (
            <>
              <div className="mt-2 mb-4">
                <BtnWrapper className={classes["btn-sec"]}>
                  {btnType1.map((type) => {
                    return (
                      <SecBTN
                        className={isPending === type && "active"}
                        onClick={() => {
                          setISPending(type);
                        }}
                        type="button"
                      >
                        {type}
                      </SecBTN>
                    );
                  })}
                </BtnWrapper>
              </div>
              {/* Filter Button */}
              <div className="text-end">
                <button
                  className={
                    filterPopup
                      ? classes["filter-btn-active"]
                      : classes["filter-btn"]
                  }
                  onClick={() => setFilterPopup(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 36 36"
                    fill="currentColor"
                  >
                    <path
                      d="M31.7137 18.8555H26.5709M11.1423 6.85547C11.597 6.85547 12.033 7.03608 12.3545 7.35757C12.676 7.67906 12.8566 8.1151 12.8566 8.56975V11.9983C12.8566 12.453 12.676 12.889 12.3545 13.2105C12.033 13.532 11.597 13.7126 11.1423 13.7126C10.6876 13.7126 10.2516 13.532 9.93012 13.2105C9.60863 12.889 9.42801 12.453 9.42801 11.9983V8.56975C9.42801 8.1151 9.60863 7.67906 9.93012 7.35757C10.2516 7.03608 10.6876 6.85547 11.1423 6.85547V6.85547ZM31.7137 10.284H12.8566H31.7137ZM9.42801 10.284H4.28516H9.42801ZM11.1423 23.9983C11.597 23.9983 12.033 24.1789 12.3545 24.5004C12.676 24.8219 12.8566 25.258 12.8566 25.7126V29.1412C12.8566 29.5958 12.676 30.0319 12.3545 30.3534C12.033 30.6749 11.597 30.8555 11.1423 30.8555C10.6876 30.8555 10.2516 30.6749 9.93012 30.3534C9.60863 30.0319 9.42801 29.5958 9.42801 29.1412V25.7126C9.42801 25.258 9.60863 24.8219 9.93012 24.5004C10.2516 24.1789 10.6876 23.9983 11.1423 23.9983ZM31.7137 27.4269H12.8566H31.7137ZM9.42801 27.4269H4.28516H9.42801ZM24.8566 15.4269C25.3112 15.4269 25.7473 15.6075 26.0688 15.929C26.3903 16.2505 26.5709 16.6865 26.5709 17.1412V20.5698C26.5709 21.0244 26.3903 21.4604 26.0688 21.7819C25.7473 22.1034 25.3112 22.284 24.8566 22.284C24.4019 22.284 23.9659 22.1034 23.6444 21.7819C23.3229 21.4604 23.1423 21.0244 23.1423 20.5698V17.1412C23.1423 16.6865 23.3229 16.2505 23.6444 15.929C23.9659 15.6075 24.4019 15.4269 24.8566 15.4269V15.4269ZM23.1423 18.8555H4.28516H23.1423Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </>
          )}
          {/* Over-all Analytics Section */}
          {activeTab == btnType[1] && isPending == btnType1[0] && (
            <OverallAnalytics />
          )}
          {/* Student-wise Analytics Section */}
          {activeTab == btnType[1] && isPending == btnType1[1] && (
            <StudentwiseAnalytics/>
          )}
        </div>
        <div className="mt-4 mb-4"></div>
      </div>
    </>
  );
}

export default Dashboard